import {isNotUndefinedAndNotNull} from "@/utils/classes";

const permissionsQuery = localStorage.getItem('userPermissions');

const userPermissions = permissionsQuery !== 'undefined' && isNotUndefinedAndNotNull(permissionsQuery) ? JSON.parse(permissionsQuery) : [];

export default {
  permissions: userPermissions,
}
